const FEATURES = [
  {
    title: '海量资源',
    desc: '收录200+韩国漫画网站，涵盖连载、完结、汉化等各类资源，满足不同读者的需求。',
    icon: 'ri-database-2-line',
  },
  {
    title: '极速更新',
    desc: '每日同步各大韩国漫画网最新动态，确保您不会错过任何一部作品的更新。',
    icon: 'ri-flashlight-line',
  },
  {
    title: '高清画质',
    desc: '精选优质韩国漫画网站资源，保障高清阅读体验，让每一格画面都清晰细腻。',
    icon: 'ri-hd-line',
  },
  {
    title: '智能推荐',
    desc: '根据热门趋势与读者口碑，智能筛选优质韩国漫画网站推荐，帮您发现好作品。',
    icon: 'ri-thumb-up-line',
  },
  {
    title: '多端同步',
    desc: '支持桌面端与移动端无缝切换，随时随地继续您的韩国漫画阅读之旅。',
    icon: 'ri-device-line',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          平台优势
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          为什么选择韩国漫画网站作为您的韩国漫画导航平台
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {FEATURES.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-50 rounded-xl p-6 text-center cursor-pointer hover:scale-[1.03] transition-all duration-300"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-accent-100/80 flex items-center justify-center">
                <i className={`${feature.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-foreground-500 text-xs leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}